<template>
  <v-container class="pt-10">
    <Heading msg="Frequently Asked Questions (FAQs)" />

    <v-expansion-panels
      class="pb-5"
      inset
      focusable
      v-for="question in filteredQuestions"
      :key="question.questionuid"
    >
      <v-expansion-panel>
        <v-expansion-panel-header disable-icon-rotate>
          {{ question.question }}
          <template v-slot:actions>
            <v-icon color="sokoDeep">mdi-plus-circle</v-icon>
          </template>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="pt-4">
          {{ question.answer }}
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <AskQuestion />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import AskQuestion from "../components/Forms/AskQuestion.vue";
import Heading from "@/components/Layout/Heading.vue";

export default {
  name: "Faqs",
  components: { AskQuestion, Heading },

  methods: {
    ...mapActions(["makeFetch"]),
  },

  async mounted() {
    await this.makeFetch({
      method: "GET",
      withId: false,
      goTo: "faq",
      addUrl: "/get-all-questions",
      stateVar: "allQuestions",
    }).catch((err) => {
      console.log(err);
      return false;
    });

    this.loading = false;

    // console.log(this.allOrders);
  },
  computed: {
    allQuestions() {
      return this.$store.getters.getCollection("allQuestions");
    },

    filteredQuestions() {
      if (!this.allQuestions) return [];
      else
        return this.allQuestions.filter(
          (question) => question.answer != null || question.question != null
        );
    },
  },
};
</script>

<style></style>
